import { render } from "./ExpiredModal2.vue?vue&type=template&id=1362988c&scoped=true"
import script from "./ExpiredModal2.vue?vue&type=script&lang=js"
export * from "./ExpiredModal2.vue?vue&type=script&lang=js"

import "./ExpiredModal2.vue?vue&type=style&index=0&id=1362988c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1362988c"

export default script